var ReasonCodeCollection = require('./collection'),
    fvChannel = require('glRadio').channel('FV');
    _ = require('underscore');


/**
 * All reason codes in the system -- active and inactive.
 * Still need all for cross reference to locally stored last codes.
 * Inactive is cached on parse for performance boost.
 */

module.exports = ReasonCodeCollection.extend({

    initialize: function() {

        // Cache the active ones on this object, set on parse
        this.activeReasonCodes = null;

        /* Cache some other values */
        this._activeReasonCodeCodes = null;
        this._sanitizedActiveReasonCodeCodes = null;


    },

    // This is for all -- active and inactive
    url: function() {
        return fvChannel.request('apiUrl').reasonCodes;
    },

    parse: function( attrs ) {

        var activeRcs = _.filter( attrs, function(rc) {
            return rc.active;
        });

        /* other option is the 'cache' approoach -- then can get out of parse */
        this.activeReasonCodes = new ReasonCodeCollection( activeRcs );

        return attrs;

    },


    getActiveReasonCodes: function() {
        return this.activeReasonCodes;
    },


    getValidAndInvalidCodesFromUserInput: function( aCodes ) {

        if ( !aCodes || aCodes.length < 1 )
            return;


        this._sanitizedActiveReasonCodeCodes = this._sanitizedActiveReasonCodeCodes || this.getActiveReasonCodes().map( function( rc ) {
            return rc.get('code').toLowerCase().trim();
        });

        var retObj = {
            validCodes: [],
            invalidCodes: []
        };

        return aCodes.reduce( function( previous, current ) {

            var indexOfCodeFromActiveSystemCodes = this._sanitizedActiveReasonCodeCodes.indexOf( current.toLowerCase().trim() );

            if (  indexOfCodeFromActiveSystemCodes > -1 ) {

                // Return the 'non-sanitized' -- we want to actual model -- caller can get the attributes from .toJSON()

                previous.validCodes.push( this.getActiveReasonCodes().at( indexOfCodeFromActiveSystemCodes ) );

            } else {

                // Return the raw value for error reporting
                previous.invalidCodes.push( current );

            }

            return previous;

        }.bind( this ), retObj );

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/reasonCodes/systemReasonCodes.js
 ** module id = 758
 ** module chunks = 0
 **/